// extracted by mini-css-extract-plugin
export default {"signin":"style_signin__x1rAR","forgot":"style_forgot__+CWvu","btnHolder":"style_btnHolder__BvYS7"};